import React from "react";
import { ClientProfileScreen } from "../../../../components/screen/ClientProfileScreen";

export function ClientProfileRoute() {
  return <ClientProfileScreen />;
}
